import { Button, Flex, Heading, Stack, Text } from '@chakra-ui/react'
import { useFlexGroup } from 'BrokerTsLib/src/hooks/useFlexGroup'
import { useNavigate, useParams } from 'react-router'

import { Container } from '@/components/Container'
import { Section } from '@/components/Section'
import { FlexGroupOrganizationListSection } from '@/containers/flex-group/FlexGroupOrganizationListSection'
import { FlexGroupTypeBadge } from '@/containers/flex-group/FlexGroupTypeBadge'
import { FlexGroupUserListSection } from '@/containers/flex-group/FlexGroupUserListSection'
import { PageContent } from '@/containers/PageContent'
import { PageToolbar } from '@/containers/PageToolbar'
import { ValidityBadge } from '@/containers/shared/ValidityBadge'
import { ArrowLeft, Edit, TextUnorderedList } from '@/icons'

export const FlexGroupDetailPage = () => {
  const navigate = useNavigate()
  const { flexGroupId: flexGroupIdParam } = useParams()
  const flexGroupId = parseInt(flexGroupIdParam ?? '')

  const {
    flexGroup,
    isLoading,
    addMemberOrganizationAsync,
    updateMemberOrganizationAsync,
    removeMemberOrganizationAsync,
    addMemberUserAsync,
    removeMemberUserAsync,
    addSupervisorOrganizationAsync,
    removeSupervisorOrganizationAsync,
    addSupervisorUserAsync,
    removeSupervisorUserAsync
  } = useFlexGroup(flexGroupId)

  return (
    <Section>
      <Container>
        <PageContent>
          <PageToolbar
            leftElements={
              <Flex sx={{ gap: 4, alignItems: 'center' }}>
                <Heading as="h1">{flexGroup?.name}</Heading>
                <FlexGroupTypeBadge type={flexGroup?.type} />
                <ValidityBadge valid={flexGroup?.valid ?? false} />
              </Flex>
            }
            rightElements={
              <Flex sx={{ gap: 4 }}>
                <Button
                  variant="ghost"
                  onClick={() => navigate('/flex-group/list')}
                >
                  <ArrowLeft color="secondary.500" />
                  Zpět na přehled flexibilních skupin
                </Button>
                <Button colorScheme="primary" onClick={() => navigate('edit')}>
                  <Edit />
                  Upravit
                </Button>
              </Flex>
            }
          />

          {flexGroup?.description && (
            <Text size={'md'} maxWidth={'xl'}>
              <TextUnorderedList boxSize={'16px'} mr={4} mt={-0.5} />
              {flexGroup?.description}
            </Text>
          )}

          <Stack>
            <FlexGroupOrganizationListSection
              title='Seznam organizací'
              description='Organizace, jejichž nabídky budou zobrazeny flexibilní skupině.'
              flexGroupOrganizations={flexGroup?.memberOrganizations ?? []}
              isLoading={isLoading}
              addOrganizationAsync={addMemberOrganizationAsync}
              updateOrganizationAsync={updateMemberOrganizationAsync}
              removeOrganizationAsync={removeMemberOrganizationAsync}
            />

            {/* <FlexGroupUserListSection
              title='Seznam uživatelů'
              description='Uživatelé, jejichž nabídky budou zobrazeny flexibilní skupině.'
              flexGroupUsers={flexGroup?.memberUsers ?? []}
              isLoading={isLoading}
              addUserAsync={addMemberUserAsync}
              removeUserAsync={removeMemberUserAsync}
            /> */}

            {/* <FlexGroupOrganizationListSection
              title='Oprávnění - organizace'
              description='Organizace, které uvidí na nabídky flexibilní skupiny.'
              flexGroupOrganizations={flexGroup?.supervisorOrganizations ?? []}
              isLoading={isLoading}
              addOrganizationAsync={addSupervisorOrganizationAsync}
              removeOrganizationAsync={removeSupervisorOrganizationAsync}
            /> */}

            <FlexGroupUserListSection
              title='Oprávnení - uživatelé'
              description='Uživatelé, kteří uvidí nabídky flexibilní skupiny.'
              flexGroupUsers={flexGroup?.supervisorUsers ?? []}
              isLoading={isLoading}
              addUserAsync={addSupervisorUserAsync}
              removeUserAsync={removeSupervisorUserAsync}
            />
          </Stack>
        </PageContent>
      </Container>
    </Section>
  )
}
